import React, { Fragment, useEffect, useState, useRef } from "react";
import styles from "./index.module.css";

import { useDreamStream } from "../useDreamStream";

import DataList, { DataRow } from "shared/DataList";
import { Section, Row, Column, LabelGroup } from "shared/layout";
import Link from "shared/Link";
import Button from "shared/Button";

import { ArrowRightTop } from "react-ikonate";
import dayjs from "dayjs";
import ReactModal from "react-modal";
import TabActionBar from "shared/TabActionBar";
import Loader from "shared/Loader";
import classNames from "classnames";

import DreamStreamHistory from "../DreamStreamHistory";
import DreamStreamOrgSync from "../DreamStreamOrgSync";
import DSInfoEdit from "../DSInfoEdit";
import AccessCodeModal from "../AccessCodeModal";

function getMemberUrl(iboNumber) {
  return `/membership/lookup/ibo/${iboNumber}`;
}

function hasIndices(arr) {
  if (Array.isArray(arr) && arr.length > 0) return true;
  return false;
}

export default function DreamStreamDetails({
  data,
  refetch,
  syncDreamStreamAccount,
  fetchIboSyncData,
  hideHeader,
  retrieveAccessCode,
  accessCode,
  clearAccessCode,
  membership,
}) {
  const {
    editDreamStreamName,
    editDreamStreamEmail,
    editDreamStreamNameAndEmail,
    cancelSyncPut,
  } = useDreamStream(data.iboNumber);

  const [contact, setContact] = useState(data);

  function orgPresent() {
    (contact.dreamStream && hasIndices(contact.dreamStream.events)) ||
      hasIndices(contact.dreamStream.ownOrganizations) ||
      hasIndices(contact.dreamStream.pluginOrganizations) ||
      hasIndices(contact.dreamStream.uplineOrganizations) ||
      hasIndices(contact.dreamStream.downlineOrganizations) ||
      hasIndices(contact.dreamStream.otherOrganizations);
    return true;
  }

  useEffect(() => {
    setContact(data);
  }, [data]);

  useEffect(() => {
    if (accessCode) {
      setIsAccessOpen(true);
    }
  }, [accessCode]);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);
  //const [isClosed, setIsClosed] = useState(false);
  const [isAccessOpen, setIsAccessOpen] = useState(false);
  const [isShowHistory, setIsShowHistory] = useState(false);

  const [editData, setEditData] = useState(null);
  const [editError, setEditError] = useState("");

  const [isUpdating, setIsUpdating] = useState(false);
  const [isBeingEdited, setIsBeingEdited] = useState(false);

  const submitNameAndEmailEdit = async (nameAndEmail) => {
    setIsUpdating(true);

    if (nameAndEmail && contact) {
      const nameEdited = nameAndEmail.name !== contact.iboInfo.name;
      const emailEdited = nameAndEmail.email !== contact.iboInfo.email;
      const req = {
        iboNumber: contact.iboNumber,
        wwgId: contact.wwgId,
        name: nameAndEmail.name,
        email: nameAndEmail.email,
      };

      var o = { ...contact }; //contact;
      if (nameEdited && emailEdited) {
        // call UserUpdatePut
        const res = await editDreamStreamNameAndEmail(req);
        if (res === "OK") {
          o.iboInfo.name = nameAndEmail.name;
          o.iboInfo.email = nameAndEmail.email;
        } else {
          if (res === "DUPLICATE") {
            setEditError(
              "ERROR: Email is currently in use by another DreamStream Account."
            );
          } else {
            setEditError(
              "There was an error while processing your request. Please try again. If the problem continues, please report to QA."
            );
          }
          return;
        }
      } else if (nameEdited) {
        // call UserNamePut
        const res = await editDreamStreamName(req);
        if (res === "OK") {
          o.iboInfo.name = nameAndEmail.name;
        } else {
          setEditError(
            "There was an error while processing your request. Please try again. If the problem continues, please report to QA."
          );
          return;
        }
      } else if (emailEdited) {
        // call UserEmailPut
        const res = await editDreamStreamEmail(req);
        if (res === "OK") {
          o.iboInfo.email = nameAndEmail.email;
        } else {
          if (res === "DUPLICATE") {
            setEditError(
              "ERROR: Email is currently in use by another DreamStream Account."
            );
          } else {
            setEditError(
              "There was an error while processing your request. Please try again. If the problem continues, please report to QA."
            );
          }
          return;
        }
      }

      setIsUpdating(false);
      setIsBeingEdited(false);
    }
  };

  const [iboSyncData, setIboSyncData] = useState(null);

  const handleCancel = () => {
    cancelSyncPut.mutate({ syncId: iboSyncData._id });
  };

  return (
    <div>
      <ReactModal
        isOpen={isHistoryOpen}
        className={styles.modal}
        overlayClassName={styles.overlay}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnOverlayEsc={true}
        onRequestClose={() => {
          setIsHistoryOpen(false);
        }}
      >
        <DreamStreamHistory
          ibo={contact}
          isCreatingIbo={false}
          isShowHistory={isShowHistory}
          showMarkComplete={iboSyncData}
          syncDreamStreamAccount={syncDreamStreamAccount}
          refresh={async (contact) => {
            await refetch(contact);
            try {
              const data = await fetchIboSyncData(contact);
              setIboSyncData(data);
            } catch (error) {
              console.error("Error fetching data: ", error);
            }
          }}
          onClose={() => {
            setIsHistoryOpen(false);
            setIsShowHistory(false);
          }}
          onCancel={handleCancel}
        ></DreamStreamHistory>
      </ReactModal>

      <ReactModal
        isOpen={isAccessOpen}
        className={styles.modal}
        overlayClassName={styles.overlay}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnOverlayEsc={true}
        onRequestClose={() => {
          setIsAccessOpen(false);
        }}
      >
        <AccessCodeModal
          onClose={() => {
            clearAccessCode();
            setIsAccessOpen(false);
          }}
          name={contact.iboInfo.name}
          accessCode={accessCode}
        ></AccessCodeModal>
      </ReactModal>

      <Section>
        {!hideHeader && (
          <TabActionBar>
            <header className={styles.tabActionBarHeader}>
              <h3>
                {contact.iboInfo.name} ({contact.iboInfo.type})
              </h3>
              <div>
                <Button
                  size="small"
                  onClick={() => {
                    setIsHistoryOpen(!isHistoryOpen);
                    setIsShowHistory(true);
                  }}
                >
                  Show History
                </Button>
                {(membership.status === "Active" ||
                  (!membership.status === "Active" && contact.wwgId)) && (
                  <>
                    &nbsp;
                    <Button
                      size="small"
                      onClick={async () => {
                        await retrieveAccessCode(contact);
                      }}
                      purpose="save"
                    >
                      Access Code
                    </Button>
                  </>
                )}
                &nbsp;
                <Button
                  size="small"
                  onClick={async () => {
                    if (!contact.isSyncing) {
                      setContact({ ...contact, actions: [], logs: [] });
                      await syncDreamStreamAccount(contact);
                    }
                    await refetch(contact);
                    setIsHistoryOpen(true);
                  }}
                  purpose="delete"
                >
                  Sync
                </Button>
              </div>
            </header>
          </TabActionBar>
        )}

        <Section>
          <header>
            <h3>DreamStream Account</h3>
            <Button
              size="small"
              disabled={isBeingEdited}
              className={styles.contactButton}
              onClick={() => {
                setEditData(contact);
                setIsBeingEdited(true);
              }}
            >
              Edit
            </Button>
          </header>
          <Row>
            <DataList>
              <DataRow label="Name">{contact.iboInfo.name}</DataRow>
              <DataRow label="Email">{contact.iboInfo.email}</DataRow>
              <DataRow label="WWG ID">{contact.wwgId}</DataRow>
            </DataList>
          </Row>
        </Section>
        {editData && isBeingEdited && (
          <div>
            <div className={styles.error}>{editError}</div>
            <DSInfoEdit
              data={editData}
              disabled={isUpdating}
              onSubmit={submitNameAndEmailEdit}
              onCancel={() => {
                setEditData(null);
                setIsBeingEdited(false);
                setEditError("");
              }}
            />
          </div>
        )}

        {contact.los && (
          <Section>
            <header>
              <h3>DreamStream LOS</h3>
            </header>
            <Row>
              <Column width="15%">
                <LabelGroup
                  title={
                    "Pin Level" +
                    (contact.los.pinLevel.isPlugin ? " (PLUGIN)" : "")
                  }
                >
                  {contact.los.pinLevel.name}
                </LabelGroup>
              </Column>

              <Column width="20%">
                <LabelGroup title={"Sponsor"}>
                  <Link to={getMemberUrl(contact.los.sponsor.iboNumber)}>
                    {contact.los.sponsor.iboNumber} {contact.los.sponsor.name}
                  </Link>
                </LabelGroup>
              </Column>
              <Column width="20%">
                <LabelGroup title={"Platinum"}>
                  <Link to={getMemberUrl(contact.los.platinum.iboNumber)}>
                    {contact.los.platinum.iboNumber} {contact.los.platinum.name}
                  </Link>
                </LabelGroup>
              </Column>
              <Column width="20%">
                <LabelGroup title={"Emerald"}>
                  <Link to={getMemberUrl(contact.los.emerald.iboNumber)}>
                    {contact.los.emerald.iboNumber} {contact.los.emerald.name}
                  </Link>
                </LabelGroup>
              </Column>
              <Column width="20%">
                <LabelGroup title={"Diamond"}>
                  <Link to={getMemberUrl(contact.los.diamond.iboNumber)}>
                    {contact.los.diamond.iboNumber} {contact.los.diamond.name}
                  </Link>
                </LabelGroup>
              </Column>
            </Row>
          </Section>
        )}
      </Section>

      {orgPresent() && (
        <Section>
          <header>
            <h3>DreamStream Organizations</h3>
            {/* <div className={styles.buttons}>Add</div> */}
          </header>

          {Object.keys(organizationTypes).map((orgType, i) => {
            let orgs = contact.dreamStream[orgType];
            let title = organizationTypes[orgType];
            return hasIndices(orgs) ? (
              <OrgList
                key={i}
                orgs={orgs}
                title={title}
                data={contact}
                refetch={refetch}
                isAccessOpen={isAccessOpen}
                setIsAccessOpen={setIsAccessOpen}
                clearAccessCode={clearAccessCode}
                accessCode={accessCode}
              />
            ) : (
              ""
            );
          })}
        </Section>
      )}
    </div>
  );
}

export function OrgList({
  orgs,
  title,
  data,
  refetch,
  isAccessOpen,
  setIsAccessOpen,
  clearAccessCode,
  accessCode,
}) {
  const [showHistory, setShowHistory] = useState(false);
  const [contact, setContact] = useState(data);
  useEffect(() => {
    setContact(data);
  }, [data]);

  return (
    hasIndices(orgs) && (
      <>
        <header>
          <h3>{title}</h3>
          {title === "Downline Organizations" && (
            <div className={styles.buttons}>
              <Button
                size="small"
                onClick={() => {
                  setShowHistory(!showHistory);
                }}
              >
                {showHistory ? "Hide Organizations" : "Show Organizations"}
              </Button>
            </div>
          )}
        </header>
        {title === "Downline Organizations" &&
        orgs === null &&
        showHistory === true ? (
          <Loader />
        ) : (
          ""
        )}
        {orgs.map((org, oi) => {
          return (
            <Fragment key={oi}>
              <div
                className={classNames(
                  styles.tableContainer,
                  title === "Downline Organizations" && showHistory === false
                    ? styles.hidden
                    : ""
                )}
                role="table"
                aria-label="Destinations"
              >
                <div
                  className={[styles.flexTable, styles.header].join(" ")}
                  role="rowgroup"
                >
                  <div
                    className={[styles.flexRow, styles.first].join(" ")}
                    role="columnheader"
                  >
                    Organization
                  </div>
                  <div className={styles.flexRow} role="columnheader">
                    Group
                  </div>
                  {title === "Events" ? (
                    ""
                  ) : (
                    <div className={styles.flexRow} role="columnheader">
                      Admin
                    </div>
                  )}
                  <div className={styles.flexRow} role="columnheader">
                    Status
                  </div>
                </div>
                <div className={styles.flexTable} role="rowgroup">
                  <div
                    className={[
                      styles.flexRow,
                      styles.rowspan,
                      styles.first,
                    ].join(" ")}
                  >
                    <div
                      className={
                        title === "Events" ? "organizationsEvents" : ""
                      }
                    >
                      {org.organizationName}
                    </div>

                    {org.iboNumber !== 0 && (
                      <div className={styles.iboNumber}>
                        <Link to={getMemberUrl(org.iboNumber)}>
                          {org.iboNumber}
                        </Link>
                      </div>
                    )}
                  </div>
                  {title === "Events" ? (
                    <div
                      className={classNames(styles.column, styles.columnEvents)}
                    >
                      <GroupEntry
                        title={title}
                        grp={org.group}
                        data={contact}
                        key={org._id + orgs.length}
                        refetch={refetch}
                        isAccessOpen={isAccessOpen}
                        setIsAccessOpen={setIsAccessOpen}
                        clearAccessCode={clearAccessCode}
                        accessCode={accessCode}
                        org={org}
                      />
                    </div>
                  ) : (
                    <div className={styles.column}>
                      {org.groups &&
                        org.groups.length > 0 &&
                        org.groups.map((grp, gi) => {
                          return (
                            <GroupEntry
                              title={title}
                              grp={grp}
                              data={contact}
                              key={gi + orgs.length}
                              refetch={refetch}
                              isAccessOpen={isAccessOpen}
                              setIsAccessOpen={setIsAccessOpen}
                              clearAccessCode={clearAccessCode}
                              accessCode={accessCode}
                              org={org}
                            />
                          );
                        })}
                    </div>
                  )}
                </div>
              </div>
            </Fragment>
          );
        })}
      </>
    )
  );
}

export function GroupEntry({
  grp,
  data,
  refetch,
  isAccessOpen,
  setIsAccessOpen,
  clearAccessCode,
  accessCode,
  org,
  title,
}) {
  const { syncOrganization, cancelSyncPut } = useDreamStream(data.iboNumber);
  const { fetchGroupSyncData } = useDreamStream();
  const location = window.location.href;
  const [contact, setContact] = useState(data);
  const [group, setGroup] = useState(grp);
  const [_org, setOrg] = useState(org);
  const [isGroupHistoryOpen, setIsGroupHistoryOpen] = useState(false);

  useEffect(() => {
    setContact(data);
  }, [data]);

  useEffect(() => {
    setGroup(grp);
  }, [grp]);

  useEffect(() => {
    setOrg(org);
  }, [org]);

  var syncObject = {
    type: "organization",
    pinLevel:
      group.groupName === "Platinumship"
        ? 2
        : group.groupName === "Emeraldship"
        ? 3
        : group.groupName === "Diamondship"
        ? 4
        : 0,
    organizationId: org.organizationId,
  };

  const [orgSyncData, setOrgSyncData] = useState(null);
  const [isSyncFinished, setIsSyncFinished] = useState(false);
  const [isSyncStarted, setIsSyncStarted] = useState(false);
  const [groupSyncData, setGroupSyncData] = useState(null);

  const handleCancelOrgSync = () => {
    cancelSyncPut.mutate({ syncId: groupSyncData._id });
  };

  return (
    <>
      <ReactModal
        isOpen={isGroupHistoryOpen}
        className={styles.modal}
        overlayClassName={styles.overlay}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnOverlayEsc={true}
        onRequestClose={() => {
          setIsGroupHistoryOpen(false);
        }}
      >
        <DreamStreamOrgSync
          orgSyncData={orgSyncData}
          ibo={contact}
          isCreatingIbo={false}
          isSyncFinished={isSyncFinished}
          isSyncStarted={isSyncStarted}
          onCancel={handleCancelOrgSync}
          showMarkComplete={groupSyncData}
          refresh={async () => {
            try {
              const data = await fetchGroupSyncData(syncObject);
              setGroupSyncData(data);
              if (data === null) {
                setIsSyncFinished(true);
                setIsSyncStarted(false);
              } else {
                setOrgSyncData(data);
              }
            } catch (error) {
              console.error("Error fetching data: ", error);
            }
          }}
          onClose={() => {
            setIsGroupHistoryOpen(false);
            if (isSyncFinished) {
              setIsSyncFinished(false);
              setIsSyncStarted(false);
            } else {
              setIsSyncStarted(true);
            }
          }}
        ></DreamStreamOrgSync>
      </ReactModal>

      <ReactModal
        isOpen={isAccessOpen}
        className={styles.modal}
        overlayClassName={styles.overlay}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnOverlayEsc={true}
        onRequestClose={() => {
          setIsAccessOpen(false);
        }}
      >
        <AccessCodeModal
          onClose={() => {
            clearAccessCode();
            setIsAccessOpen(false);
          }}
          name={contact.iboInfo.name}
          accessCode={accessCode}
        ></AccessCodeModal>
      </ReactModal>

      <div className={styles.flexRow}>
        <div
          className={classNames(
            title === "Events" ? styles.flexCellEvents : styles.flexCell
          )}
          role="cell"
        >
          {group.groupName ? (
            <div className={styles.groupRow}>
              <div className={styles.groupLink}>
                <div className={styles.groupName}>{group.groupName} </div>
                <Link
                  to={
                    location.includes("localhost:") ||
                    location.includes("dev.wwg.support")
                      ? `https://dev.dreamstream.today/groups/${group.groupId}`
                      : location.includes("staging.wwg.support")
                      ? `https://staging.dreamstream.today/groups/${group.groupId}`
                      : location.includes("wwg.support") &&
                        `https://www.dreamstream.today/groups/${group.groupId}`
                  }
                  target="_blank"
                >
                  <ArrowRightTop />
                </Link>
              </div>
              {group.groupName &&
                group.groupName !== "WWG" &&
                title &&
                title === "Own Organizations" && (
                  <div className={styles.syncBtn}>
                    {" "}
                    <Button
                      size="small"
                      onClick={async () => {
                        setIsGroupHistoryOpen(true);
                        try {
                          const data = await fetchGroupSyncData(syncObject);
                          if (data === null) {
                            setOrgSyncData(null);
                            await syncOrganization(syncObject);
                            setIsSyncStarted(true);
                          } else {
                            setOrgSyncData(data);
                          }
                        } catch (error) {
                          console.error("Error fetching data: ", error);
                        }
                      }}
                      purpose="delete"
                    >
                      Sync
                    </Button>
                  </div>
                )}
            </div>
          ) : (
            "No Group Name"
          )}
        </div>

        {title === "Events" ? (
          ""
        ) : (
          <div className={styles.flexCell} role="cell">
            {group.isAdmin ? "Yes" : "No"}
          </div>
        )}

        <div
          className={classNames(
            title === "Events" ? styles.flexCellEvents : styles.flexCell
          )}
          role="cell"
        >
          {group.deletedOn
            ? `Deleted on ${dayjs(group.deletedOn)
                .tz("America/Los_Angeles")
                .format("MM/DD/YY HH:mm:ss A")} PT`
            : group.addedOn == null
            ? "Not Created"
            : group.verifiedOn == null && title !== "Events"
            ? "Added (Unverified)"
            : group.addedOn
            ? "Added on " +
              dayjs(group.addedOn)
                .tz("America/Los_Angeles")
                .format("MM/DD/YY HH:mm:ss A") +
              " PT"
            : ""}
        </div>
      </div>
    </>
  );
}

const organizationTypes = {
  events: "Events",
  ownOrganizations: "Own Organizations",
  pluginOrganizations: "Plugged Into Organizations",
  uplineOrganizations: "Upline Organizations",
  otherOrganizations: "Other Organizations",
  downlineOrganizations: "Downline Organizations",
};
